import { getArgsAsTypesafeObjectProperties } from "../constants-util";

export const constants = getArgsAsTypesafeObjectProperties(
  "NotificationContent",
  "ShowNotifcationDrawer"
);
